import { QuickSwitch, QuickSwitchItem } from '../insight/config.insight.model';
import { BaseState, defaultBaseState } from '../insight/insight.state';

export const storeStateMapper = (state: any): RootState => ({
    ...state.performanceInsight,
    ...state.insight,
});

export interface LevelOptionState {
    pending: boolean;
    quickSwitch?: QuickSwitch;
    filteredItems?: QuickSwitchItem[];
    active?: QuickSwitchItem;
    canChangeActive?: boolean;
}

export interface RootState extends BaseState {
    levelOpt?: LevelOptionState;
}

export const defaultState = (): RootState => ({
    ...defaultBaseState(),
    levelOpt: {
        pending: false,
    },
});
